import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-logout',
  templateUrl: './icon-logout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconLogoutComponent {}
